import BannerHero from "@/components/bannerHero";
import Image from "next/image";
import { useMemo, useState } from "react";
import { activities } from "@/db/activityData";
import { FiChevronLeft, FiChevronRight } from "react-icons/fi";
import SidebarLayout from "@/components/layout/SidebarLayout";

const ITEMS_PER_PAGE = 6;

export default function ExtraCurricular() {
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedTerm, setSelectedTerm] = useState("Term 1 (Fall) - Aug to Dec");

  const filteredActivities = useMemo(() => {
    return activities.filter((activity) => activity.term === selectedTerm);
  }, [selectedTerm]);

  const totalPages = Math.ceil(filteredActivities.length / ITEMS_PER_PAGE);

  const paginatedActivities = useMemo(() => {
    const start = (currentPage - 1) * ITEMS_PER_PAGE;
    return filteredActivities.slice(start, start + ITEMS_PER_PAGE);
  }, [currentPage, filteredActivities]);

  return (
    <>
      <BannerHero
        title="Extra-Curricular"
        bgImage="/images/about-bg.png"
        className="about"
      />

      <SidebarLayout
        navTitle="Extra-Curricular"
        sidebarHeader="Extra-Curricular"
        onLinkClick={(title) => {
          setSelectedTerm(title);
          setCurrentPage(1);
        }}
      >
        <section className="home-special-course empty-area">
          <div className="row">
            {paginatedActivities.map((item) => (
              <div key={item.id} className="col-lg-6 col-md-6 mb-4">
                <div className="single-home-special-course mt-0">
                  <div className="course-img border-radius">
                    <Image
                      src={item.image}
                      alt={item.name}
                      width={400}
                      height={500}
                      className="img-fluid img-width"
                    />

                    <div className="course-content">
                      <h2>{item.name}</h2>
                      <p>{item.description}</p>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* ===== Pagination ===== */}
          {totalPages > 1 && (
            <div className="pagination-wrapper">
              {/* Prev */}
              <button
                className="pagination-arrow"
                disabled={currentPage === 1}
                onClick={() => setCurrentPage((p) => Math.max(1, p - 1))}
              >
                <FiChevronLeft />
              </button>

              {/* Numbers */}
              {[...Array(totalPages)].map((_, i) => {
                const page = i + 1;
                return (
                  <button
                    key={page}
                    className={`pagination-number ${page === currentPage ? "active" : ""
                      }`}
                    onClick={() => setCurrentPage(page)}
                  >
                    {page}
                  </button>
                );
              })}

              {/* Next */}
              <button
                className="pagination-arrow"
                disabled={currentPage === totalPages}
                onClick={() =>
                  setCurrentPage((p) => Math.min(totalPages, p + 1))
                }
              >
                <FiChevronRight />
              </button>
            </div>
          )}
        </section>
      </SidebarLayout>
    </>
  );
}
